import React from "react";
import PropTypes from "prop-types";
import "./ProductDetails.scss";

const ProductHeader = ({ formattedCost = "", title }) => (
    <div className="store-details__container--header">
        <h2>{title}</h2>
        <div className="-no-margin--top -type--large">{formattedCost}</div>
    </div>
);

ProductHeader.propTypes = {
    formattedCost: PropTypes.string,
    title: PropTypes.string.isRequired,
};

export default ProductHeader;
